// converter for each sponsored product on listing page
import { formatPrice } from '@codex/helpers';
import { convertImageUrlFromBrainToSmallerImage } from './helpers/converterHelper';
import Configuration from '../../../configuration';


export default function convertSponsoredProducts(products) {
  // get value of criteo cookie
  // if the cookie is defined, it's later added as a url parameter 'puserid' at the end of onLoadBeacon property and
  // at the end of every product's link, beacons.onView beacons.onClick properties
  const criteoCookieValue = getCriteoCookieValue();

  if (products.onLoadBeacon && products.items) {
    return {
      onLoadBeacon: criteoCookieValue
        ? `${products.onLoadBeacon}&puserid=${criteoCookieValue}`
        : products.onLoadBeacon,
      items: products.items.slice(0, 4).map((item) => convertProduct(item, criteoCookieValue))
    };
  }

  return null;
}

function getCriteoCookieValue() {
  const criteoCookieRegexResult = document.cookie.match('(^|;) ?criteo=([^;]*)(;|$)');

  return criteoCookieRegexResult ? criteoCookieRegexResult[2] : '';
}

function convertProduct(item, criteoCookieValue) {
  return {
    id: item.id,
    brand: convertBrand(item.brand),
    title: item.label,
    link: `${convertLink(item.link)}${criteoCookieValue ? `&puserid=${criteoCookieValue}` : ''}`,
    image: {
      src: item.images[0] && item.images[0].url // eslint-disable-line no-nested-ternary
        // Because there are a very little amount of small images on dev, we use big images on dev
        ? (Configuration.get('listingPage.useSmallSizeProductImage')
          ? convertImageUrlFromBrainToSmallerImage(item.images[0].url)
          : item.images[0].url)
        : 'https://currys-ssl.cdn.dixons.com/grafx/images/logos/logo.png', // if image no coming from brain add Currys logo
      label: item.label
    },
    icons: item.icons.map((icon) => ({ imgUrl: icon.imageUrl, linkUrl: icon.link })),
    price: convertPrice(item.price, item.wasPrice),
    promoMessages: {
      isOnlineOnly: false,
      badges: convertBadges(item.badges || [])
    },
    hasOurExpertsLoveTag: false,
    isOutOfStock: false,
    isFlashSale: false,
    descriptionShortened: convertDescription(item.fullDescription),
    descriptionBullets: item?.mainFeatures?.length > 0
      ? item.mainFeatures.slice(0, 5)
      : [],
    review: convertReview(item.customerReview),
    displayCompare: true,
    beacons: convertBeaconsForProduct(item.beacons, criteoCookieValue),
    deliveryOptions: item.deliveryOptions,
    preOrder: item.preOrder,
    sponsored: true
  };
}

function convertBrand(brand) {
  const title = brand && brand.label ? brand.label : '';
  return { title };
}

function convertLink(link) {
  return link ? link : '#';
}

function convertReview(customerReview) {
  if (customerReview && customerReview.number && customerReview.averageScore) {
    return {
      reviewCount: customerReview.number,
      score: customerReview.averageScore
    };
  }

  return undefined;
}

function convertBeaconsForProduct(beacons, criteoCookieValue) {
  const convertedBeacons = {};

  if (beacons.onClick) {
    convertedBeacons.onClick = criteoCookieValue
      ? `${beacons.onClick}&puserid=${criteoCookieValue}`
      : beacons.onClick;
  }

  if (beacons.onView) {
    convertedBeacons.onView = criteoCookieValue
      ? `${beacons.onView}&puserid=${criteoCookieValue}`
      : beacons.onView;
  }

  return convertedBeacons;
}

function convertPrice(price, wasPrice) {
  const formattedPrice = formatPrice(price.amount, true, price.currencyCode);
  const formattedWasPrice = wasPrice &&
    formatPrice(wasPrice.amount, true, wasPrice.currencyCode);
  const formattedSavingsPrice = wasPrice &&
    formatPrice(wasPrice.discountAmount, true, wasPrice.currencyCode);

  return {
    currentPrice: formattedPrice,
    wasPrice: formattedWasPrice ? formattedWasPrice : null,
    savingsPrice: formattedSavingsPrice ? formattedSavingsPrice : null,
    wasPriceFrom: wasPrice && wasPrice.dateFrom && formatDate(wasPrice.dateFrom),
    wasPriceTo: wasPrice && wasPrice.dateTo && formatDate(wasPrice.dateTo)
  };
}


function formatDate(date) {
  return date.split('-').reverse().join('/');
}

function convertDescription(description) {
  return `${removeHtml(description).slice(0, 250)}...`;
}

function convertBadges(badges) {
  return badges.map((item) => ({
    src: item.imageUrl,
    label: item.name
  }));
}

function removeHtml(text) {
  return text.replace(/<[^>]+>/g, '');
}
